/**
 * VxeTable 全局配置
 *
 * 用于复杂数据表格场景：业态规划、落位总览、财务报表等
 * 简单列表页继续使用 el-table
 *
 * @see https://vxetable.cn/
 */
import VxeUITable from 'vxe-table'
import VxeUI from 'vxe-pc-ui'
import VxeUIPluginRenderElement from '@vxe-ui/plugin-render-element'
import vxeZhCN from 'vxe-pc-ui/lib/language/zh-CN.js'
import vxeEnUS from 'vxe-pc-ui/lib/language/en-US.js'

// 样式导入
import 'vxe-pc-ui/lib/style.css'
import 'vxe-table/lib/style.css'
import '@vxe-ui/plugin-render-element/lib/style.css'

// 注册 Element Plus 渲染插件
VxeUI.use(VxeUIPluginRenderElement)

// 设置默认语言
VxeUI.setI18n('zh-CN', vxeZhCN)
VxeUI.setI18n('en-US', vxeEnUS)
VxeUI.setLanguage('zh-CN')

// 全局默认配置
VxeUI.setConfig({

  // 表格全局默认
  table: {
    border: true,
    stripe: true,
    showOverflow: 'tooltip',
    showHeaderOverflow: 'tooltip',
    autoResize: true,
    size: 'medium',
    align: 'center',
    headerAlign: 'center',
    rowConfig: { isCurrent: true, isHover: true },
    columnConfig: { resizable: true },
  },

  // 分页全局默认
  pager: {
    pageSize: 20,
    pageSizes: [10, 20, 50, 100],
    layouts: ['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total'],
  },

  // 工具栏全局默认
  // 注意：zoom 仅在 vxe-grid 中生效，standalone vxe-toolbar 需自行实现全屏按钮
  toolbar: {
    export: { types: ['csv', 'html'] },
    print: true,
    custom: true,
  },
})

/**
 * 安装 VxeTable 到 Vue 应用
 * @param {import('vue').App} app
 */
export function setupVxeTable(app) {
  app.use(VxeUI)
  app.use(VxeUITable)
}

/**
 * Switch VxeTable locale
 * @param {'zh-CN' | 'en-US'} locale
 */
export function switchVxeTableLocale(locale) {
  VxeUI.setLanguage(locale)
}
